/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalPythonGraderModelAccess = {
  None: "none",
  Mka1: "mka1",
} as const;
export type EvalPythonGraderModelAccess = ClosedEnum<
  typeof EvalPythonGraderModelAccess
>;

/** @internal */
export const EvalPythonGraderModelAccess$inboundSchema: z.ZodNativeEnum<
  typeof EvalPythonGraderModelAccess
> = z.nativeEnum(EvalPythonGraderModelAccess);
/** @internal */
export const EvalPythonGraderModelAccess$outboundSchema: z.ZodNativeEnum<
  typeof EvalPythonGraderModelAccess
> = EvalPythonGraderModelAccess$inboundSchema;
